export default {
  identifyGroupCode: '标识组代码',
  identifyGroupName: '标识组名称',
  identifyCode: '标识代码',
  identifyName: '标识名称',
  indentifyClass: '标识类别',
  indentifyType: '标签类别',
  pleaseSelectIdentifyLevel: '请选择标签级别',
  ConfirmDeleteTheIdentifyGroup: '是否确定要删除该标识组?',
  pleaseSelectIdentifyGroup: '请先选择标识组',
  createIdentifyGroup: '新增标识组',
  editIdentifyGroup: '编辑标识组',
  viewIdentifyGroup: '查看标识组',
  createIdentify: '新增标识',
  editIdentify: '编辑标识',
  viewIdentify: '查看标识',
  pleaseSelectDeleteIdentify: '请选择需要删除的标识',
  confirmDeleteTheIdentify: '是否确定要删除该标识',
}
